import React, { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom';
import "./Refiller.css";
import { Cookies } from "react-cookie";
import axios from "axios";
import { ErrorAlert, SuccessAlert } from "../middleware/AlertMsg";
import { FaTrash } from "react-icons/fa";
import Loading from "../Loading";
import { useNavigate } from "react-router";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
  } from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'
const EditRefillRequest = () => {
    const { id } = useParams();
    const cookies = new Cookies();
    const token = cookies.get("JWTcookie");
    const [isLoading, setLoading] = useState(true)
    const [machine, setMachine] = useState();
    const [returnItems, setReturnItems] = useState([]);
    const navigate = useNavigate();
    const [productList, setProductList] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [isSearchVisible, setSearchVisible] = useState(false);
    //const baseUrl = "https://officejeeves.com";
    const baseUrl = process.env.REACT_APP_BASE_URL
    const [ID, setId] = useState()
    const suggestionsContainerRef = useRef(null);
    const [isVisibleArray, setIsVisibleArray] = useState([]);
    const fields = [
        "Slot Name",
        "Product",
        "Closing Stock",
        "Current Stock",
        "Refill Qty",
        "Sale Qty",
    ]
    const [sales, setSales] = useState({
        cash: 0,
        totalSalesCount: "",
        totalSalesValue: ""
    })

    const getRefillRequestDetails = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${baseUrl}/api/refillRequest/${id}`, { headers: { 'Authorization': 'Bearer ' + token } })
            const data = res.data.data;
            // console.log('data: ', data);
            setMachine(data)
            setReturnItems(data.returnItems);
            setSales(data.sales);
            setIsVisibleArray(new Array(data.machineSlots.length).fill(false))
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
            ErrorAlert({
                title: "Fail",
                message: error,
            });
        }
    };

    useEffect(() => {
        getRefillRequestDetails();
        fetchProductList();
    }, [id]);

    const fetchProductList = async () => {
        try {
            const res = await axios.get(`${baseUrl}/api/Product/Datalist`, {
                headers: { Authorization: "Bearer " + token },
            });
            // console.log('res: ', res);
            setProductList(res.data.data); // Assuming the API response is an array of products
            setFilteredProducts(res.data.data);
        } catch (error) {
            // console.log(error);
            ErrorAlert({
                title: "Fail",
                message: error.message,
            });
        }
    };

    const handleSearch = (e, id, index) => {
        setSearchVisible(true)
        setId(id);
        const value = e.target.value;
        const updatedVisibleArray = isVisibleArray.map((visible, i) =>
            i === index ? true : false
        );
        // console.log('updatedVisibleArray: ', updatedVisibleArray);
        setIsVisibleArray(updatedVisibleArray);
        const filtered = productList.filter(product =>
            product.productname.toLowerCase().includes(value.toLowerCase())
        );
        const newmachineSlots = machine.machineSlots.map((item, i) => {
            if (id === item._id) {
                return {
                    ...item,
                    productid: {
                        ...item.productid,
                        productname: value,
                    }
                }
            }
            else {
                return item
            }
        })
        // setUpdatedSlots((prevState) => ({ ...prevState, machineSlot: newupdatedSlots }));
        setMachine((prev) => ({ ...prev, machineSlots: newmachineSlots }));
        setFilteredProducts(filtered);
    };

    const handleRefillQty = (id, e) => {
        const value = e.target.value;
        const newmachine = machine.machineSlots.map((input) => {
            if (input._id === id) {
                const refillValue =
                    value <= 25 && value >= 0
                        ? value
                        : null;
                if (value > 25 || value < 0) {
                    e.target.value = refillValue;
                    alert("Refill Quantity not greater than Slot capacity or Value should not be Negative");
                }

                return {
                    ...input,
                    refillQuantity: refillValue,
                };
            }
            return input;
        });
        setMachine((prevState) => ({ ...prevState, machineSlots: newmachine }));
    };

    const handleCurrentStock = (id, e) => {
        // console.log('id: ', id);
        const value = e.target.value; // 5
        const newmachine = machine.machineSlots.map((item) => {
            if (item._id === id) {
                const CurrentStockValue = (value <= item.closingStock) && value >= 0 ? value : null;
                if (value > item.closingStock || value < 0) {
                    alert("Current Stock is not greater than Closing Stock");
                    e.target.value = CurrentStockValue
                }
                return {
                    ...item,
                    currentStock: CurrentStockValue,
                    saleQuantity: Number(value) <= item.closingStock && Number(value) >= 0 && value !== "" ? item.closingStock - Number(value) : null,
                };
            }

            return item;
        });
        // console.log('newmachine: ', newmachine);
        setMachine((prevState) => ({ ...prevState, machineSlots: newmachine }));
    };

    // const handleDelete = (id) => {
    //     const shouldDelete = window.confirm("Are you sure to delete this item ?");
    //     // console.log('shouldDelete: ', shouldDelete);
    //     if (!shouldDelete) {
    //         return;
    //     }
    //     const removedItem = machine?.machineSlots.find((item) => item._id === id);
    //     if (removedItem) {
    //         if (removedItem.currentStock === null || removedItem.currentStock === "") {
    //             return alert("Please First fill current Stock Of Item")
    //         }
    //         // Update the returnItems state by adding the removed item
    //         const arr = [...returnItems, { ...removedItem, refillQuantity: 0 }];
    //         setReturnItems(arr);
    //         // setUpdatedSlots({ ...machine, machineSlot: arr });
    //         // setUpdatedSlots(prev => [...prev, { ...removedItem, productname: "" }]);
    //         // Initialize isVisibleArray with false values
    //         setIsVisibleArray(new Array(arr.length).fill(false));
    //     }
    //     const newData = machine.machineSlots.filter((item, i) => id !== item._id);
    //     setMachine({ ...machine, machineSlots: newData });
    // };

    const handleProductUpdateSlot = (product) => {
        setSearchVisible(false);
        const newupdatedSlots = machine.machineSlots.map((item, i) => {
            if (ID === item._id) {
                return {
                    ...item,
                    productid: {
                        ...item.productid,
                        productname: product.productname,
                        sellingprice: product.sellingprice,
                        _id: product._id,
                    }
                }
            }
            else {
                return item
            }
        })
        // console.log('newupdatedSlots: ', newupdatedSlots);
        setMachine((prev) => ({ ...prev, machineSlots: newupdatedSlots }));
        setIsVisibleArray(new Array(newupdatedSlots.length).fill(false));
    }

    const handleSubmit = async () => {
        const payload = { ...machine, returnItems, sales }
        // console.log('payload: ', payload);
        if (sales.cash === "" || sales.totalSalesCount === "" || sales.totalSalesValue === "") {
            return alert("Please Enter Sales Value")
        }
        try {
            setLoading(true)
            const res = await axios.put(
                `${baseUrl}/api/refill/request/${id}`,
                payload,
                { headers: { Authorization: "Bearer " + token } }
            );
            const data = res.data;
            // console.log('data: ', data);
            if (data.success) {
                setLoading(false)
                SuccessAlert({
                    title: "Success",
                    message: "Slots update Request send successfully",
                });
                navigate("/managerefillrequest")
            } else {
                setLoading(false)
                ErrorAlert({
                    title: "Fail",
                    message: "Request not send successfully,Please try again",
                });
            }
        } catch (error) {
            // console.log(error);
            ErrorAlert({
                title: "Fail",
                message: error,
            });
            setLoading(false)
        }
    };
    // console.log('isVisibleArray: ', isVisibleArray);
    // console.log("updatedSlots",updatedSlots);
    // console.log("machine", machine);
    // console.log('filteredProducts: ', filteredProducts);

    return (
        <div className="table_container-div">
            {
                isLoading ?
                    <Loading /> :
                    <>
                        <button className="refillerbackbtn"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            Back
                        </button>
                        <div className="selectMachine">
                            <label> Edit Refill Sheet :</label>
                        </div>
                        <div>
                            <div className="tcontainer">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <StyledTableRow>
                                           <HeaderTableCell align='center'>Machine Name</HeaderTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell align='center'>{machine?.machineId.machinename}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                                <Table>
                                   <TableHead>
                                        <StyledTableRow>
                                            <HeaderTableCell>Slot Name</HeaderTableCell>
                                            <HeaderTableCell>Product</HeaderTableCell>
                                            <HeaderTableCell>Closing Stock</HeaderTableCell>
                                            <HeaderTableCell>Current Stock</HeaderTableCell>
                                            <HeaderTableCell>Refill Qty</HeaderTableCell>
                                            <HeaderTableCell>Sale Qty</HeaderTableCell>
                                            {/* <th>Action</th> */}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {machine?.machineSlots.sort((a, b) => a.slot.localeCompare(b.slot)).map((item, index) => (
                                            <StyledTableRow key={item.id} sx={{
                                                backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                                            }}>
                                                <StyledTableCell>{item.slot}</StyledTableCell>
                                                <StyledTableCell >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            position: "relative"
                                                        }}
                                                    >
                                                        <input
                                                            style={{ padding: '7px', frontWeight: 'bold', fontSize: '16px' }}
                                                            type="text"
                                                            value={item.productid.productname}
                                                            onClick={(e) => {
                                                                setSearchVisible(!isSearchVisible)
                                                                setIsVisibleArray(new Array(machine.machineSlots.length).fill(false))
                                                            }}
                                                            onChange={(e) => handleSearch(e, item._id, index)}
                                                        />
                                                        {isVisibleArray[index] && isSearchVisible && (
                                                            <div
                                                                ref={suggestionsContainerRef}
                                                                style={{
                                                                    minWidth: "300px",
                                                                    margin: "auto",
                                                                    maxHeight: "200px",
                                                                    overflowY: "auto",
                                                                    backgroundColor: "white",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    padding: "3px 3px",
                                                                    boxShadow: "rgba(0, 0, 0, 0.4) 0px 30px 90px",
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    right: "1%",
                                                                    zIndex: "999999"
                                                                }}
                                                            >
                                                                {filteredProducts.map((product, index) => (
                                                                    <div
                                                                        key={product._id}
                                                                        onClick={() => handleProductUpdateSlot(product)}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            padding: "3px 10px 0px",
                                                                            boxShadow: "rgba(0, 0, 0, 0.45) 0px 25px 20px -20px",
                                                                            borderBottom: "1px solid gray",
                                                                        }}
                                                                    >
                                                                        {product.productname} {product.sellingprice}Rs
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell align='right'>{item.closingStock}</StyledTableCell>
                                                <StyledTableCell className="tbody_td">
                                                    <input
                                                        className="td_input"
                                                        type="number"
                                                        value={item.currentStock || ""}
                                                        min="0"
                                                        placeholder={item.currentStock}
                                                        onChange={(e) => handleCurrentStock(item._id, e)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell className="tbody_td">
                                                    <input
                                                        className="td_input"
                                                        type="number"
                                                        value={item.refillQuantity}
                                                        min="0"
                                                        placeholder={item.refillQuantity || ""}
                                                        onChange={(e) => handleRefillQty(item._id, e)}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell align='right'>{item.saleQuantity}</StyledTableCell>
                                                {/* <td>
                                                    <div className="actionsBtn">
                                                        <FaTrash onClick={() => handleDelete(item._id)} />
                                                    </div>
                                                </td> */}
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                            {machine?.returnItems.length > 0 ?
                                <div>
                                    <div style={{
                                        width: "90%", display: 'flex', margin: "auto", justifyContent: 'flex-start', marginTop: "15px",
                                        backgroundColor: "black", color: "white", padding: "7px"
                                    }}>
                                        <p>Return Items :</p>
                                    </div>
                                    <Table>
                                        <TableHead>
                                            <StyledTableRow>
                                                {fields.map((item, i) => (
                                                    <th key={i + 1}>{item}</th>
                                                ))}
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {machine?.returnItems
                                                .map((item, index) => (
                                                    <StyledTableRow key={item.id} sx={{
                                                        backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                                                    }}>
                                                        <StyledTableCell>{item.slot}</StyledTableCell>
                                                        <StyledTableCell>{item.productid.productname}</StyledTableCell>
                                                        <StyledTableCell align='right'>{item.closingStock}</StyledTableCell>
                                                        <StyledTableCell align='right'>{item.currentStock}</StyledTableCell>
                                                        <StyledTableCell align='right'>{item.refillQuantity}</StyledTableCell>
                                                        <StyledTableCell align='right'>{item.saleQuantity}</StyledTableCell>
                                                    </StyledTableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </div>
                                :
                                <div></div>
                            }
                            <div className="cashContainer">
                                <label>Cash:</label>
                                <input
                                    placeholder="Enter Cash value"
                                    type="number" min={0}
                                    value={sales.cash}
                                    onChange={(e) => setSales({ ...sales, cash: e.target.value })} />
                                <label>Total Sales Count:</label>
                                <input
                                    placeholder="Enter Sales count"
                                    type="number" min={0}
                                    value={sales.totalSalesCount}
                                    onChange={(e) => setSales({ ...sales, totalSalesCount: e.target.value })} />
                                <label>Total Sales Value:</label>
                                <input
                                    placeholder="Enter Sales value"
                                    type="number" min={0}
                                    value={sales.totalSalesValue}
                                    onChange={(e) => setSales({ ...sales, totalSalesValue: e.target.value })} />
                            </div>
                            <div className="input-lable-v-div">
                                <button className="submit-btn" onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </>
            }
        </div>
    )
}

export default EditRefillRequest